import { render } from "./ChildProductOverlay.vue?vue&type=template&id=57c18c0c&scoped=true"
import script from "./ChildProductOverlay.vue?vue&type=script&lang=js"
export * from "./ChildProductOverlay.vue?vue&type=script&lang=js"

import "./ChildProductOverlay.vue?vue&type=style&index=0&id=57c18c0c&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c18c0c"]])

export default __exports__